import { EmptyState } from '@/components/ui/EmptyState';
import { UI_STRINGS } from '@/lib/constants/ui-strings';

/**
 * Placeholder shown for an entity type whose profile fields/endpoint are not
 * built yet. Keeps every persona profile route valid while the per-type
 * variants land (ADR FE-1).
 */
export function ProfileComingSoon() {
  return (
    <EmptyState
      title={UI_STRINGS.PROFILE.COMING_SOON_TITLE}
      description={UI_STRINGS.PROFILE.COMING_SOON_DESC}
    />
  );
}

/**
 * `Sections` placeholder for a `coming-soon` registry module. Matches the
 * module `Sections` signature so a module can register before its real form
 * exists; never rendered while `status: 'coming-soon'` (ProfileEditor short
 * circuits), but keeps the module type total.
 */
export function ComingSoonSections(_props: { data: unknown; readOnly: boolean }) {
  return <ProfileComingSoon />;
}
